(function () {
  var strictDietaryQueries = {
    glutenfrei: 'tag:Glutenfrei',
    halal: 'tag:Halal'
  };

  var dietaryDisplayQueries = {
    'tag:glutenfrei': 'glutenfrei',
    'tag:halal': 'halal',
    'tag:"filter_eigenschaften:glutenfrei"': 'glutenfrei',
    'tag:"filter_eigenschaften:halal"': 'halal'
  };

  window.getStorefrontSearchQuery = function (query) {
    var trimmedQuery = String(query || '').trim();
    var normalizedQuery = trimmedQuery.toLowerCase();

    return strictDietaryQueries[normalizedQuery] || trimmedQuery;
  };

  window.getStorefrontSearchDisplayQuery = function (query) {
    var decodedQuery = String(query || '')
      .replace(/&quot;|&#34;|&#x22;/gi, '"')
      .trim();

    return dietaryDisplayQueries[decodedQuery.toLowerCase()] || decodedQuery;
  };

  document.querySelectorAll('form input[name="q"]').forEach(function (queryInput) {
    queryInput.value = window.getStorefrontSearchDisplayQuery(queryInput.value);

    var form = queryInput.closest('form');

    if (form) form.setAttribute('data-strict-dietary-search', '');
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-strict-dietary-search]');

    if (!form) return;

    var queryInput = form.querySelector('[name="q"]');

    if (!queryInput) return;

    var strictQuery = window.getStorefrontSearchQuery(queryInput.value);

    if (strictQuery === queryInput.value.trim()) return;

    var strictQueryInput = document.createElement('input');
    strictQueryInput.type = 'hidden';
    strictQueryInput.name = 'q';
    strictQueryInput.value = strictQuery;
    form.appendChild(strictQueryInput);
    queryInput.removeAttribute('name');

    window.setTimeout(function () {
      queryInput.setAttribute('name', 'q');
      strictQueryInput.remove();
    }, 0);
  }, true);
})();
